module.exports = __webpack_public_path__ + "static/media/summary_mobile.310906aa.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/summary_mobile.jpg
 ** module id = 960
 ** module chunks = 0
 **/